import { Check } from 'lucide-react';

const images = {
  finops: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cloud%20Migration/finops.avif',
  security: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cloud%20Migration/Security_image.webp',
  managed: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cloud%20Migration/cloud_mig_4.png?updatedAt=1788860449754',
};

const colors = {
  blue: '#0B3B78',
  muted: '#526377',
  border: '#DCE3EC',
};

function SectionHeading({ title, text, centered = false }) {
  return <div className={centered ? 'cloud-centered mx-auto max-w-6xl text-center' : 'max-w-6xl'}>
    <h2 className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>{title}</h2>
    {text && <p className="mt-5 text-base font-normal leading-[27px]" style={{ color: '#212121' }}>{text}</p>}
  </div>;
}

export default function CloudOperations() {
  return (<section className="px-5 py-16 sm:px-6 lg:px-10 lg:py-12"><div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-2 lg:items-center lg:gap-16">
      <div><SectionHeading title="A cloud that keeps working after go-live" text="Moving workloads is one milestone. The real value comes from an environment that stays healthy, understandable and adaptable as your business changes." /><div className="mt-8 space-y-5">{[
        ['Operational visibility', 'Monitoring, alerting and service reviews help teams spot issues and understand what changed.'],
        ['Security in daily operations', 'Access reviews, configuration checks and response processes keep controls active.'],
        ['Continuous optimization', 'Capacity, performance and cloud spend are reviewed against actual use and priorities.'],
      ].map(([title, text]) => <div key={title} className="flex gap-4 border-t pt-5" style={{ borderColor: colors.border }}><Check size={19} className="mt-1 shrink-0" style={{ color: colors.blue }} aria-hidden="true" /><div><h3 className="text-lg font-semibold" style={{ color: '#183762' }}>{title}</h3><p className="mt-1 text-base font-normal leading-[27px]" style={{ color: '#212121' }}>{text}</p></div></div>)}</div></div>
      <div className="grid grid-cols-2 gap-3"><img src={images.managed} alt="Managed cloud services" className="col-span-2 h-64 w-full object-cover sm:h-80" loading="lazy" /><img src={images.security} alt="Cloud security" className="h-36 w-full object-cover sm:h-48" loading="lazy" /><img src={images.finops} alt="Cloud cost management" className="h-36 w-full object-cover sm:h-48" loading="lazy" /></div>
    </div></section>);
}
